<template>
	<section class="email-check">
		<TnHeading
			v-if="content.title"
			type="h3"
			size="l"
			class="margin-vertical-l"
			responsive
			>{{ content.title }}
		</TnHeading>

		<div class="email-check-input">
			<div class="email-check-input-left">
				<TnTextField
					v-model="emailAddress"
					ref="emailInput"
					size="m"
					icon-left="email"
					:label="(content.inputEmail && content.inputEmail.textlabel) || 'Epost'"
					:placeholder="content.inputEmail.placeholder"
					class="margin-bottom-m email-check-input-field"
					required
					clearable
					@keydown.enter="checkEmail"
					@cleared="handleClear"
				>
					<template
						#hint
						v-if="emailAddress && emailAddress.length === 0"
						>Dette feltet er obligatorisk</template
					>
					<template
						#warning
						v-if="emailAddress && emailAddress.length > 3 && !isValidEmail"
						>Ugyldig format på e-posten</template
					>
				</TnTextField>
			</div>
			<div class="email-check-input-right">
				<TnButton
					@click="checkEmail"
					:disabled="loading"
					:loading="loading"
					size="m"
					>{{ content.submitButton.text }}
				</TnButton>
			</div>
		</div>

		<div
			v-if="showResults"
			class="padding-vertical-m"
		>
			<RichText
				:text="breachResult"
				:class="results === 'error margin-top-m' ? 'fail margin-top-m' : 'margin-top-m'"
			/>
		</div>

		<div class="eyeonid">Levert av EyeOnID i samarbeid med Telenor</div>
	</section>
</template>

<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";

export default defineNuxtComponent({
	name: "EmailBreachCheck",

	mixins: [GizmoComponentMixin],

	computed: {
		breachResult() {
			if (this.results === "error") return this.content.errorMessage;
			if (this.results?.match && this.content.breachMessage) {
				if (this.results?.numberOfMatches)
					return this.content.breachMessage.replace(/#N/g, this.results.numberOfMatches.toString());
				return this.content.breachMessage;
			}
			return this.content.noBreachMessage;
		},
		redirect() {
			return this.content.redirect;
		},
		isValidEmail() {
			const pattern = "^\\s*([\\w\\._+-]+)@([\\w\\._+-]+)\\.([A-Za-z\\._+-]{2,})\\s*$";
			return RegExp(pattern).test(this.emailAddress);
		},
	},

	data() {
		return {
			emailAddress: "",
			loading: false,
			results: {},
			showResults: false,
		};
	},

	methods: {
		async checkEmail() {
			if (!this.emailAddress || !this.isValidEmail) {
				this.$refs.emailInput.$el.getElementsByTagName("input")[0]?.focus();
				return;
			}

			this.loading = true;
			this.showResults = false;

			try {
				const response = await $fetch("/api/eyeonid/email-breach-check", {
					method: "POST",
					body: { email: this.emailAddress },
				});

				if (response?.match) {
					this.sendTracking("Breach");
					if (this.content.redirect && this.content.redirectLinkBreach)
						this.$router.push(this.content.redirectLinkBreach);
				} else if (!response?.match) {
					this.sendTracking("No breach");
					if (this.content.redirect && this.content.redirectLinkNoBreach)
						this.$router.push(this.content.redirectLinkNoBreach);
				}

				this.results = response;
			} catch (error) {
				console.log(error);
				this.results = "error";
				this.sendTracking("Error");
			} finally {
				this.showResults = true;
				this.loading = false;
			}
		},
		handleClear() {
			this.emailAddress = "";
			this.showResults = false;
		},
		sendTracking(result) {
			try {
				this.$track({
					events: { event79: 1 },
					email_check: result,
				});
			} catch (e) {
				console.log(e);
			}
		},
	},
});
</script>

<style lang="scss" scoped>
.email-check {
	.eyeonid {
		text-align: center;
		margin-top: $spacing-m;
		color: $color-neutrals-600-shade;

		@include font-text-xs;
	}

	&-input {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		gap: $spacing-m;

		&-left {
			width: 100%;
		}

		&-right {
			margin-top: 24px;

			@include breakpoint(mobile) {
				margin-top: 0;
			}
		}

		&-field {
			@include breakpoint(mobile) {
				margin: 0;
			}
		}

		@include breakpoint(mobile) {
			flex-wrap: wrap;
		}
	}

	.fail {
		font-style: italic;
		color: $color-critical-500-core;
	}

	@include breakpoint(mobile) {
		padding: 0;
	}
}
</style>
